import { useMemo } from 'react';

import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { bpCombined } from '../../../../../../mask-overlays/mask-overlay/views/erp/hooks/use-bz-shadow-object-api/use-shadow-bz-object-graphql';

const ENTITIES_TO_CHECK_CONVERT_PERMISSION_ERP: Entities[] = [
  Entities.calculation,
  Entities.offer,
  Entities.contract,
  Entities.invoice,
  Entities.deliveryNote,
  Entities.demand,
  Entities.order,
  Entities.inboundDeliveryNote,
];

export const ENTITIES_TO_CHECK_CONVERT_PERMISSION_CRM: Entities[] = [
  Entities.callMemo,
  Entities.note,
];

export const ENTITIES_TO_CHECK_CONVERT_PERMISSION: Entities[] = [
  ...ENTITIES_TO_CHECK_CONVERT_PERMISSION_ERP,
  ...ENTITIES_TO_CHECK_CONVERT_PERMISSION_CRM,
];

// Base: only top-level id
export const BASE_REQUEST_DATA_ID_ONLY = {
  id: null,
} as const;

// Additional shape: business partner/contact combined
export const REQUEST_DATA_WITH_BP_COMBINED = {
  businessPartnerContactCombined: bpCombined,
} as const;

const DEFAULT_ERP_REQUEST_DATA = {
  ...BASE_REQUEST_DATA_ID_ONLY,
  ...REQUEST_DATA_WITH_BP_COMBINED,
} as const;

export const REQUEST_DATA_BY_ENTITY: Partial<Record<Entities, unknown>> = {
  ...ENTITIES_TO_CHECK_CONVERT_PERMISSION.reduce<Record<string, unknown>>(
    (acc, entity) => {
      acc[entity] = DEFAULT_ERP_REQUEST_DATA;
      return acc;
    },
    {}
  ),
  [Entities.invoice]: {
    ...DEFAULT_ERP_REQUEST_DATA,
    positionList: [{ id: null, amount: null }],
  },
};

export function useEntityRequestData(
  monitorItem: unknown,
  sourceEntity: Entities
): { skip: boolean; requestData: DataRequest } {
  return useMemo<{ skip: boolean; requestData: DataRequest }>(() => {
    const data = (REQUEST_DATA_BY_ENTITY[sourceEntity] ??
      DEFAULT_ERP_REQUEST_DATA) as unknown;
    return {
      skip: ENTITIES_TO_CHECK_CONVERT_PERMISSION_CRM.includes(sourceEntity),
      requestData: {
        filter: [{ id: { $eq: (monitorItem as { id?: number })?.id } }],
        entity: sourceEntity,
        data,
      },
    };
  }, [monitorItem, sourceEntity]);
}
